import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: 100%;
`;

declare type CreditCardContainerProps = {
    $theme?: string
}

export const CreditCardContainer = styled.div<CreditCardContainerProps>`
    width: 80%;
    max-width: 344px;
    min-height: 180px;
    background-color: ${({ $theme }: { $theme?: string }) => $theme || '#2666cf'};
    color: #FFFFFF;
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    padding: 24px;
    box-sizing: border-box;
`;

export const Header = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
`;

export const CardTitle = styled.span`
    font-size: 14px;
    line-height: 1;
    font-weight: 400;
`;

export const BrandIcon = styled.img`
    width: 54px;
    height: auto;
`;

export const NumberRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 70px;
`;

export const MaskedNumber = styled.span`
    font-size: 14px;
    line-height: 1;
    letter-spacing: 2px;
    white-space: nowrap;
`;

export const LastDigits = styled.span`
    font-size: 14px;
    line-height: 1;
    font-weight: 400;
    margin-left: auto;
`;

export const HolderName = styled.span`
    font-size: 14px;
    line-height: 1.1;
    font-weight: 400;
    margin-top: 30px;
`;
